<template>
    <div class="mx-3">
    <div class="text-left">
    <p>
        Thank you for your interest in our daily learning on mobile phones Study.
        We are conducting a research study to examine people's learning and memory.
    </p>
    <p>
        You will do a series of tasks on your <b>smartphone</b>. You will learn and make
        judgments about causal relationships over 26 days.
    </p>
    <div>
        <p>There are <b>three</b> parts to the study.</p>
        <ul>
            <li>On the first day (Day 1), you will receive a video call from our research
                assistant and do a task, which will last about 20 minutes.</li>
            <li>During the days in-between (Day 2 to Day 25), you will
                complete 4 tasks each day on your phone for 24 days. You will
                receive text reminders to complete the tasks daily at four
                different times of the day.
                (Our earliest possible time window for completing a task is
                9AM to 10 AM; our latest possibly time window is 8pm - 9 pm.)
                On Day 1, you will receive information
                about the exact time window of each task. Each task lasts less
                than 1 minute, and you will have a 1-hour window to complete
                each task.
                </li>
            <li>On the last day (Day 26) you will do a task on your phone that
                will last about 5 minutes. You must be in a quiet place where you
                can concentrate (e.g., at home, at a library).</li>
        </ul>
    </div>
    <div>
        <p>
            <b>Text Reminders: </b>You will receive reminders by text every 15 minutes
            to remind you to
            participate in each task. Once you have participated for a given task,
            you will not receive any more reminders until the next task.
        </p>
        <p><b>Missing Tasks: </b>
            You must complete the tasks within the assigned time windows. Otherwise,
            it will count as missing a task. While we understand that
            occasionally you might miss a task, please note that you are only
            allowed to miss up to 4 tasks throughout the 26-day experiment.
            If you miss more than 4 tasks, your participation will be terminated
            and you will not receive the compensation.
        </p>
        <p>If you miss a session, your learning task for that day will be paused,
            and you will need to make up for the day you missed in the next day. This means
            that the entire experiment will take 27 days instead of the original 26 days.</p>
    </div>
    <div>
        <p>
            <b>Cell Phone Charges:</b> If you use your phone to access the website
            via a cellular (instead of WiFi) connection, standard cellular data
            charges depending on your data plan will apply. In addition, you will
            receive up to 4 text messages for each task in a day. Standard text
            message charges may apply from your wireless provider, depending
            on your text message plan.
        </p>
        <p>
            <b>Course Credit:</b> You will receive 3 credits if you complete the entire study.
            If you stop participating or skip more than 4 tasks, you will not receive the credits.
            There are other ways
            you can satisfy your course requirements and you are not obligated to
            participate in this study.
        </p>
    </div>
    <div>
    <p>
        <b>In order to participate, you must:</b>
        <ul>
        <li><b>You must be at least 18 years old.</b></li>
        <li><b>Be in the EST (Eastern) time zone for the duration of the study.</b></li>
        <li>Own a smartphone, a text-messaging plan and access to data or wifi</li>
        <li>Be able to use Zoom on a <b>computer</b> for a 20-minute video call</li>
        <li><b>You must pay attention, read instructions, and answer to the best of your ability.
            There will be some questions designed simply to make sure that you are paying attention,
                and if you answer in a way that it is obvious you are not paying attention then you
                will not be allowed to continue with the study and you will not be paid.</b></li>
        </ul>
    </p>
   <p> <b>Risks and Benefits:</b> There are no foreseeable risks or benefits.</p>
    <p> <b>Confidentiality:</b> You will submit your responses via a website. Standard practices
        will be employed to keep your data secure; however, there is no way to guarantee
        confidentiality on the internet. Your answers may be shared with other researchers
        after removing personally identifying information. </p>
    <p>
        If you are interested in participating, click the button below to signup. If you have any
        questions, please contact us at learningdailystudy@gmail.com.
    </p>
    </div>
    <p style="color: red">Before scheduling an appointment on this website,
        please first sign up for a timeslot on the SONA system (This is very
        important. If you don't sign up in SONA, you cannot receive
        credits). <br><br>When scheduling an appointment with us,
        please select a time that is no later
        than <b>March 24th</b>.
    </p>
    </div>
</div>
</template>
<style scoped>
a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
}
</style>
<script>
export default {
  data() {
    return {
      showPayment: false,
    };
  },
};
</script>
